import React from 'react';
import DOMPurify from 'dompurify';
import { formatMoney } from './../Utils';

export function MoneyFormatCustom({ price, format, removeDecimals, roundDecimals, roundDecimalsValue }) {
    const formattedMoney = formatMoney(price, format, removeDecimals, roundDecimals, roundDecimalsValue);

    if (formattedMoney.isHtml) {
        const safeHtml = DOMPurify.sanitize(formattedMoney.value, { ALLOWED_TAGS: ['span', 'svg', 'path'] });

        return (
            <span dangerouslySetInnerHTML={{ __html: safeHtml }} />
        );
    }

    return <span>{formattedMoney.value}</span>;
}